// extracted by mini-css-extract-plugin
module.exports = {"nav-h32":"Navigation_nav-h32__9rm4c","spaced":"Navigation_spaced__2BAi2"};